import * as THREE from './three.min';
import { SVGLoader } from "./SVGLoader";
// import {Line2} from "../../../utils/basejs/Line2";
// import {LineGeometry} from "../../../utils/basejs/LineGeometry";

const dfFont = {
    font : null,
    mat : null
};
// function addTorusGeometry(x, y, z,arcGeometry,material,group,lineWidth) {
//     // let arcGeometry = new THREE.TorusGeometry(x, y, 16, 16, Math.PI);
//     // let material = new THREE.MeshBasicMaterial({color: 0x32cd32});
//     const mesh = new THREE.Mesh(arcGeometry, material);
//     mesh.position.set(x, y-lineWidth, z);
//     console.log(mesh);
//     group.add(mesh);
// }
function addStableArrow(arrows, geo, timeStableArrowGroup) {
    for (const arrow of arrows) {
        const mesh = new THREE.Mesh(geo, arrow.material);
        if (arrow.direction === 1) {
            mesh.rotateZ(-Math.PI / 2);
        } else if (arrow.direction === 2) {
            mesh.rotateZ(Math.PI / 2);
        } else if (arrow.direction === 4) {
            mesh.rotateZ(Math.PI);
        }
        mesh.position.set(arrow.position.x, arrow.position.y, arrow.position.z);
        timeStableArrowGroup.add(mesh);
    }
}
function addFont(texts, material, timeFontGroup) {
    if(dfFont.font) {
        for (const text of texts) {
            const textShape = dfFont.font.generateShapes(text.text, text.size);
            const fontGeo = new THREE.ShapeGeometry(textShape);
            fontGeo.computeBoundingBox();
            const fontMesh = new THREE.Mesh(fontGeo, text.material);
            fontMesh.position.set(text.position.x, text.position.y, text.position.z);
            if (text.name) {
                fontMesh.name = text.name;
            }
            timeFontGroup.add(fontMesh);
        }
    }else{
        const loader = new THREE.FontLoader();
        loader.load('../fonts/tnmkFonts.json', function (font) {
            if (dfFont.font === null) {
                dfFont.font = font;
                dfFont.mat = material;
            }
            for (const text of texts) {
                const textShape = font.generateShapes(text.text, text.size);
                const fontGeo = new THREE.ShapeGeometry(textShape);
                fontGeo.computeBoundingBox();
                const fontMesh = new THREE.Mesh(fontGeo, text.material);
                fontMesh.position.set(text.position.x, text.position.y, text.position.z);
                if (text.name) {
                    fontMesh.name = text.name;
                }
                timeFontGroup.add(fontMesh);
            }
        });
    }
}
function addConstFont(loader,texts, material, constObject) {
    if(dfFont.font) {
        for (const text of texts) {
            const textShape = dfFont.font.generateShapes(text.text, text.size);
            const fontGeo = new THREE.ShapeGeometry(textShape);
            fontGeo.computeBoundingBox();
            const fontMesh = new THREE.Mesh(fontGeo, text.material);
            fontMesh.position.set(text.position.x, text.position.y, text.position.z);
            if (text.name) {
                fontMesh.name = text.name;
                if(constObject){
                    constObject[text.name] = fontMesh;
                }
            }

        }
    }else{
        loader.load('fonts/tnmkFonts.json', function (font) {
            if (dfFont.font === null) {
                dfFont.font = font;
                dfFont.mat = material;
            }
            for (const text of texts) {
                const textShape = font.generateShapes(text.text, text.size);
                const fontGeo = new THREE.ShapeGeometry(textShape);
                fontGeo.computeBoundingBox();
                const fontMesh = new THREE.Mesh(fontGeo, text.material);
                fontMesh.position.set(text.position.x, text.position.y, text.position.z);
                if (text.name) {
                    fontMesh.name = text.name;
                    if(constObject){
                        constObject[text.name] = fontMesh;
                    }
                }
            }
        });
    }
}

/*const addLine =( lineGroup,mat, points, positions, name )=> {
    const geometry = new LineGeometry();
    geometry.setPositions( points );
    const line = new Line2( geometry, mat );
    // line.scale.set( 1, 1, 1 );
    line.computeLineDistances();
    line.position.set( positions.x, positions.y, positions.z );
    if ( name ) {
        line.name = name;
    }
    lineGroup.add(line);
}*/

function addSvg(loader, svgGroup, position, url, rotate, isFillColor) {
    const group1 = new THREE.Group();
    // const svgMaterial = new THREE.MeshBasicMaterial( { color:0xFFF, side: THREE.DoubleSide } );
    const svgMaterial = new THREE.MeshBasicMaterial({ side: THREE.BackSide, opacity: 0 });
    loader.load(url, function (data) {
        for (const path of data.paths) {
            const fillColor = path.userData.style.fill;
            const shapes = SVGLoader.createShapes(path);
            if (isFillColor) {
                if (fillColor !== undefined && fillColor !== 'none') {
                    const material = new THREE.MeshBasicMaterial({
                        color: new THREE.Color().setStyle(fillColor),
                        opacity: path.userData.style.fillOpacity,
                        transparent: path.userData.style.fillOpacity < 1,
                        side: THREE.DoubleSide,
                        depthWrite: false,
                    });
                    for (const shape of shapes) {
                        const geometry = new THREE.ShapeGeometry(shape);
                        const mesh = new THREE.Mesh(geometry, material);
                        // mesh.scale.set(10, 10, 10);
                        mesh.rotateY(Math.PI);
                        // if (position) {
                        //     mesh.position.set(position.x, position.y, position.z);
                        // }
                        group1.add(mesh);
                        geometry.dispose();
                    }
                    material.dispose();
                }
            } else {
                for (let shape of shapes) {
                    const geometry = new THREE.ShapeGeometry(shape);
                    const mesh = new THREE.Mesh(geometry, svgMaterial);
                    // mesh.scale.set(1,0.1,0.1);
                    mesh.rotateY(Math.PI);
                    group1.add(mesh);
                    geometry.dispose();
                    svgMaterial.dispose();
                }
            }
        }

        if (rotate) {
            group1.rotateZ(Math.PI - rotate);
        } else {
            group1.rotateZ(Math.PI);
        }
        // group1.position.set( position.x , position.y  , position.z  );
        group1.position.set(position.x, position.y, position.z);
        svgGroup.add(group1);
    });

}
function clearScene(scene) {
    if(!scene){
        return;
    }
    const sceneChild = scene.children;
    const childLength = sceneChild.length;
    if(childLength > 0) {
        let i = 0;
        for(;i < childLength;i++){
            const item = sceneChild[0];
            if (item.children.length > 0) {
                clearScene(item);
            } else {
                if (item instanceof THREE.Mesh || item instanceof THREE.Line) {
                    if (item.material.map && item.material.map.dispose){
                        item.material.map.dispose();
                        item.material.map = null;
                    }
                    item.geometry.dispose(); // 删除几何体
                    item.material && item.material.dispose && item.material.dispose(); // 删除材质
                } else if (item.material) {
                    item.material.dispose();
                }
            }
            scene.remove(item);
            item.remove();
        }
    }
    scene.remove();
}
function addConstShape(shapeInfos, group) {
    for (const shape of shapeInfos) {
        const geo = new THREE.ShapeGeometry(shape.shape);
        const mesh = new THREE.Mesh(geo, shape.material);
        mesh.position.set(shape.position.x, shape.position.y, shape.position.z);
        if(shape.name){
            mesh.name = shape.name;
        }
        if(shape.rotate){
            mesh.rotateY(shape.rotate);
        }
        if(group){
            group.add(mesh);
        }
        geo.dispose();
    }
}
function addShape(shapeInfos, timeShapeGroup, svgLoader) {
    for (const shape of shapeInfos) {
        if(shape.shapeMesh) {
            shape.shapeMesh.position.set(shape.position.x, shape.position.y, shape.position.z);
            if (shape.line) {
                // shape.shapeMesh.add(addLineShape(shape.shape, shape.lineShapeMat, shape.scale));
                if (shape.scale) {
                    shape.line.scale.set(shape.scale.x, shape.scale.y, shape.scale.z);
                } else {
                    shape.line.scale.set(1, 1, 1);
                }
                shape.shapeMesh.add(shape.line);
            }
            if (shape.rotate) {
                shape.shapeMesh.rotateZ(shape.rotate);
            }
            if (shape.svgPosition) {

                addSvg(svgLoader, shape.shapeMesh, shape.svgPosition, shape.url, shape.rotate, shape.isFillColor,shape.svgMaterial);
            }
            if(shape.bh){
                shape.shapeMesh.bh = shape.bh;
            }
            if(shape.name){
                shape.shapeMesh.name = shape.name;
            }
            timeShapeGroup.add(shape.shapeMesh);

        }else{
            const geo = new THREE.ShapeGeometry(shape.shape);
            const mesh = new THREE.Mesh(geo, shape.material);
            mesh.position.set(shape.position.x, shape.position.y, shape.position.z);
            if (shape.lineShapeMat) {
                mesh.add(addLineShape(shape.shape, shape.lineShapeMat, shape.scale));
            }
            if (shape.rotate) {
                mesh.rotateZ(shape.rotate);
            }
            if (shape.svgPosition) {
                addSvg(svgLoader, mesh, shape.svgPosition, shape.url, shape.rotate, shape.isFillColor);
            }
            if(shape.bh){
                mesh.bh = shape.bh;
            }
            if(shape.name){
                mesh.name = shape.name;
            }
            timeShapeGroup.add(mesh);
            geo.dispose();
        }

    }
}
function addLineShape(shape, mat, scale) {
    const geometryPoints = new THREE.BufferGeometry().setFromPoints(shape.getPoints());
    const line = new THREE.Line(geometryPoints, mat);
    if (scale) {
        line.scale.set(scale.x, scale.y, scale.z);
    } else {
        line.scale.set(1, 1, 1);
    }
    return line;
}

export {
    addStableArrow,addShape,addFont,dfFont,addConstShape,addConstFont,addSvg,clearScene
}
